import { combineReducers } from 'redux';
import { map } from './map/reducer';
import { baseLayers } from './baseLayers/reducer';
import { schoolMenu } from './schoolMenu/reducer';
import { studentsMenu } from './studentsMenu/reducer';
import { population } from './population/reducer';
import { sportInfrastructure } from './sportInfrastructure/reducer';
import { mobility } from './mobility/reducer';
import { mapData } from './mapData/reducer';
import { pointSizeSlider } from './pointSizeSlider/reducer';
import { popup } from './popup/reducer';
import { electricUsage } from './electricUsage/reducer';
import { munRegion } from './munRegion/reducer';
import { filters } from './filters/reducer';
import { search } from './search/reducer';
import { routing } from './routing/reducer';
import { contextmenu } from './contextmenu/reducer';
import { mapMistakes } from './mapMistakes/reducer';
import { personSearch } from './personSearch/reducer';
import { draw } from './draw/reducer';
import { url } from './urlRouting/reducer';

const mainReducer = combineReducers({
  map,
  baseLayers,
  schoolMenu,
  population,
  sportInfrastructure,
  mobility,
  studentsMenu,
  mapData,
  pointSizeSlider,
  popup,
  electricUsage,
  munRegion,
  filters,
  search,
  routing,
  contextmenu,
  mapMistakes,
  personSearch,
  draw,
  url
});

export default mainReducer;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/reducers.js